import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { ButtonPressedEvent } from '../../shared/events/button-pressed.event';
import { ButtonActionTypes, ButtonPressedActionsUnion } from './buttons.action';

export const inRoomButtonsFeatureKey = 'inroom-buttons';

export type ButtonsState = EntityState<ButtonPressedEvent>;

export function selectIdFromButtonPress(buttonPress: ButtonPressedEvent) {
  return selectButtonPressedId(buttonPress.HotelCode, buttonPress.UnitCode);
}

export function selectButtonPressedId(hotelCode: string, room: string) {
  return hotelCode + '-' + room;
}

export const adapter: EntityAdapter<ButtonPressedEvent> = createEntityAdapter<ButtonPressedEvent>({
  selectId: selectIdFromButtonPress,
});

export const initialState: ButtonsState = adapter.getInitialState();

export function buttonsReducer(state: ButtonsState = initialState, action: ButtonPressedActionsUnion): ButtonsState {
  switch (action.type) {
    case ButtonActionTypes.BUTTON_SIGNALR_STATE_CHANGED:
      return adapter.upsertOne(action.payload, state);
    case ButtonActionTypes.BUTTON_PLAYER_ACTION_COMPLETED:
      return adapter.removeOne(selectButtonPressedId(action.payload.HotelCode, action.payload.UnitCode), state);
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectButtonsIds = selectIds;

export const selectButtonsEntities = selectEntities;

export const selectAllButtons = selectAll;
